import { createContext, useContext } from "react";

export const WindowDockedContext = createContext(false);

export function useWindowDocked(): boolean {
    return useContext(WindowDockedContext);
}
